<template>
  <div>
    <ItemTitle title="健康指南"></ItemTitle>
    <div
      v-for="(item, index) in guides"
      :key="index"
      class="health-item"
      :class="[printing ? 'printheigh' : '']"
    >
      <RowItem :item="item"></RowItem>
      <DashedLine class="line"></DashedLine>
      <div v-if="newpage(index + 1)" class="page"></div>
    </div>
    <div class="page"></div>
    <SupportCompany :class="[printing ? 'company' : '']"></SupportCompany>
  </div>
</template>

<script>
import RowItem from "./item.vue";
import DashedLine from "../dashedline.vue";
import ItemTitle from "../title.vue";
import SupportCompany from "../supportcompany.vue";
export default {
  components: {
    RowItem,
    DashedLine,
    ItemTitle,
    SupportCompany,
  },
  computed: {
    //奇数
    OddItem() {
      return this.$store.state.StateItemTotal % 2 == 1;
    },
    ReportData() {
      return this.$store.state.ReportData;
    },

    guides() {
      return (this.ReportData || {}).guides || [];
    },
    printing() {
      return this.$store.state.Printing;
    },
    justpage() {
      return this.newpage(this.guides.length);
    },
  },
  methods: {
    newpage(index) {
      //上面拱下来了一个，第2个就分页，单独的每页4个
      if (this.OddItem) {
        return (index - 2) % 4 == 0;
      } else {
        return index % 4 == 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.health-item {
  position: relative;
  .line {
    position: absolute;
    bottom: 0;
  }
}
.printheigh {
  height: 280px;
}
.company {
  margin-top: -140px;
}
</style>